import React from "react";
import { Sun, CloudSun, Cloud } from "lucide-react";

/**
 * sunLabel + sunIcon — normalize a raw sun_preference string ("full_sun",
 * "partial_sun", "shade") into a human-readable label + matching icon.
 * Shared by the Result page's Sun card. `t` is the react-i18next
 * translator so callers can localize without importing it here.
 */
export function sunLabel(s, t) {
  if (s === "full_sun") return t("result.sunFull");
  if (s === "partial_sun") return t("result.sunPartial");
  if (s === "shade") return t("result.sunShade");
  return s;
}

export function sunIcon(s) {
  if (s === "full_sun") return <Sun className="w-4 h-4" strokeWidth={1.5} />;
  if (s === "partial_sun") return <CloudSun className="w-4 h-4" strokeWidth={1.5} />;
  return <Cloud className="w-4 h-4" strokeWidth={1.5} />;
}
